/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GoogleReviewService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Demander un avis Google a un client
     * Envoie au client `client_id`, par `channel` (`sms` ou `email`), une invitation a laisser un avis Google apres l'intervention `intervention_id`, et enregistre la demande. 422 `{ error }` si le client n'est pas eligible (deja sollicite, pas de coordonnees, avis Google non configure). Reponse : `{ message, data }`.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public googleReviewSend(
        requestBody: {
            client_id: number;
            intervention_id: number;
            channel: 'sms' | 'email';
        },
    ): CancelablePromise<{
        message: string;
        data: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/google-review/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Un avis a-t-il deja ete demande ?
     * Reponse : `{ already_requested }` pour l'intervention donnee.
     * @param interventionId
     * @returns any
     * @throws ApiError
     */
    public googleReviewCheck(
        interventionId: number,
    ): CancelablePromise<{
        already_requested: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/google-review/check/{interventionId}',
            path: {
                'interventionId': interventionId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
